<template>
  <div class="c-userStatus">
    <div
      class="c-userStatus_text -lastLogin"
      v-if="!isEditable"
    >
      最終ログイン：{{ $util.prettyDate(lastLoginedAt) }}
    </div>
    <div
      class="c-userStatus_text -status"
      v-if="isEditable"
    >
      <div class="c-userStatus_control">
        <label>稼働状況</label>
        <b-dropdown
          :mobile-modal="false"
          v-model="attributes.kind"
          class="c-userStatus_controlDropdown"
        >
          <button
            class="button is-small"
            slot="trigger"
          >
            <span>{{ currentStatus.text }}</span>
            <b-icon icon="menu-down"></b-icon>
          </button>

          <b-dropdown-item
            v-for="status in USER_STATUSES"
            :value="status.value"
            :key="status.value"
          >{{ status.text }}</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div
      class="c-userStatus_text -status"
      v-else-if="attributes.kind"
    >
      稼働状況：{{ currentStatus.text }}
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  props: {
    isEditable: {
      type: Boolean,
      default: false
    },
    userStatus: {
      type: Object,
      default() {
        return {
          kind: 0
        }
      }
    },
    lastLoginedAt: {
      type: Number
    }
  },
  data() {
    return {
      attributes: {
        kind: this.userStatus && this.userStatus.kind ? this.userStatus.kind : 0
      }
    }
  },
  methods: {
    ...mapActions({
      doUpdate: 'pages/users/my/user/updateStatus'
    })
  },
  watch: {
    attributes: {
      deep: true,
      handler(v) {
        this.doUpdate(v).then(() => {
          this.$notify({
            group: 'flash',
            type: 'success',
            title: '稼働状況を更新しました'
          })
        })
      }
    }
  },
  computed: {
    USER_STATUSES() {
      return this.$store.getters['constants/userStatuses']
    },
    currentStatus() {
      let kind = this.attributes.kind || 1
      return this.USER_STATUSES.find(s => s.value === kind)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-userStatus {
  width: 170px;
  max-width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &_text {
    white-space: nowrap;
    font-size: 12px;
    color: $color-gray-800;
    &.-lastLogin {
    }
    &.-status {
    }
  }
  &_control {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 12px;
  }
  &_controlDropdown {
  }

  @media (max-width: $breakpoint-m) {
    flex-direction: row;
    justify-content: flex-start;
    width: 100%;
    max-width: 100%;
    margin-top: 8px;
    &_text {
      .c-userStatus_text + & {
        &::before {
          content: '/';
          margin: 0 0.5em;
        }
      }
    }
    &_control {
      justify-content: flex-start;
      flex-direction: row;
      label {
        margin-right: 10px;
      }
    }
  }

  @media (max-width: $breakpoint-s) {
    margin-top: 2px;
    &_text {
      font-size: 10px;
      color: $color-font-light;
    }
  }
}
</style>
